import { RATING_AGENCIES_MAP } from '@/finsight/ui/components/bonds/helpers';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';

import styles from '../tooltipStyles.scss';

export const RatingsTitles = {
  [RATING_AGENCIES_MAP.ratingMoodys]: 'Moody’s Rating',
  [RATING_AGENCIES_MAP.ratingSAndP]: 'S&P Rating',
  [RATING_AGENCIES_MAP.ratingFitch]: 'Fitch Rating',
  [RATING_AGENCIES_MAP.ratingDBRS]: 'DBRS Rating',
  [RATING_AGENCIES_MAP.ratingKroll]: 'Kroll Rating',
};

const getRating = (item) => (item && item.length ? item[0].abbreviation : '-');

export const RatingsCell = ({ row }) => {
  const ratings = Object.values(RATING_AGENCIES_MAP)
    .slice(0, 5);
  const ratingValues = ratings.map((id) => ({
    ratingId: id,
    value: getRating(row.ratings[id]),
  }));

  const value = ratingValues.map(({ value }, i, array) => `${ value }${ i !== (array.length - 1) ? '/' : '' }`);

  const tooltipContent = (
    <div className={ styles.tooltipBox }>
      { ratingValues.map(({
        ratingId,
        value,
      }) => (
        <div key={ ratingId }>
          <span className={ styles.name }>{ RatingsTitles[ratingId] }</span>
          <span className={ styles.value }>{ value }</span>
        </div>
      )) }
    </div>
  );

  return (
    <Tooltip
      placement="bottom"
      content={ tooltipContent }
    >{ value }
    </Tooltip>
  );
};

export default RatingsCell;
